export const ONBOARDING = {
    ID:"350a3050-c0f7-11ef-b57a-03ea338ae610"
}